import AssessmentIcon from "@mui/icons-material/Assessment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import VerifiedIcon from "@mui/icons-material/Verified";

export const dashboardIconConfig = {
  calendar: {
    color: "#16add0",
    Icon: CalendarMonthIcon,
  },
  validator: {
    color: "#7653a4",
    Icon: VerifiedIcon,
  },
  status: {
    color: "#dc6098",
    Icon: FactCheckIcon,
  },
  legacy: {
    color: "#999999",
    Icon: AssessmentIcon,
  },
  // These are unused, but just stubbing out a palette for now
  red: {
    color: "#e3555f",
    Icon: VerifiedIcon,
  },
  orange: {
    color: "#e99e4a",
    Icon: VerifiedIcon,
  },
  yellow: {
    color: "#ebd427",
    Icon: VerifiedIcon,
  },
  green: {
    color: "#8ad121",
    Icon: VerifiedIcon,
  },
} as const;
